module.exports = __webpack_public_path__ + "33bcff2bf383a59711363f0a1ee87320.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-9.png
// module id = 1483
// module chunks = 0